const communities = [
  { name: "Meridian", zip: "83642" },
  { name: "Nampa", zip: "83651" },
  { name: "Eagle", zip: "83616" },
  { name: "Garden City", zip: "83714" },
  { name: "Star", zip: "83669" },
  { name: "Kuna", zip: "83634" },
  { name: "Caldwell", zip: "83605" },
  { name: "Middleton", zip: "83644" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
              Serving Boise and All of Ada County
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves the entire Boise metro area. Whether you&apos;re in the Bench neighborhood, Boise State University area, or a surrounding city like Meridian or Eagle — we handle your expedited passport needs remotely. No trip to the Seattle Regional Agency (700+ miles away) required.
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-plane-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">Boise Airport (BOI)</p>
                  <p className="text-gray-500 text-xs">International flights — gateway to the Pacific Northwest and beyond</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-government-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">Ada County Clerk&apos;s Office</p>
                  <p className="text-gray-500 text-xs">Local acceptance facility for new passport applications</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-map-pin-2-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">Nearest Regional Agency: Seattle, WA</p>
                  <p className="text-gray-500 text-xs">700+ miles northwest — skip the trip with Fast Passport Center</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-5">Nearby Communities We Serve</p>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="flex items-center gap-3 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                    <i className="ri-map-pin-line text-[#1A365D] text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{c.name}</p>
                    <p className="text-gray-400 text-xs">ZIP {c.zip}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}